"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _package = _interopRequireDefault(require("../../package.json"));

var _v = _interopRequireDefault(require("uuid/v4"));

var _util = require("../util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var campaignId = 'RequestACall';
var TZ = '(UTC-07:00) Arizona';

var ChatbotsApiUtil =
/*#__PURE__*/
function () {
  function ChatbotsApiUtil() {
    _classCallCheck(this, ChatbotsApiUtil);
  }

  _createClass(ChatbotsApiUtil, null, [{
    key: "getMessageText",
    value: function getMessageText(item, variables) {
      if (item.payload && item.payload.type === 'text') {
        var messages = [{
          label: item.payload.text || '',
          defaultLabel: item.payload.defaultText || ''
        }];
        var replacedMessages = this.performReplacements(messages, variables);

        if (replacedMessages && replacedMessages.length === 1 && replacedMessages[0].label) {
          return replacedMessages[0].label;
        }
      }

      return item && item.type === 'text' && item.text || '';
    }
  }, {
    key: "getDiagnostics",
    value: function getDiagnostics(item) {
      var diagnostics = [{
        v: _package["default"].version
      }, {
        botProjectId: ''
      }, {
        product: 'stuff'
      }];
      diagnostics.push({
        displayName: item && item.intent && item.intent.displayName
      });
      item.sentimentAnalysisResult && diagnostics.push({
        sentiment: item.sentimentAnalysisResult.queryTextSentiment.score
      });

      if (item.search && item.search.context) {
        diagnostics.push({
          query: item.search.context.query
        });
        diagnostics.push({
          type: item.search.context.type
        });
        diagnostics.push({
          field: item.search.context.field
        });
      }

      return diagnostics;
    }
  }, {
    key: "applyVariables",
    value: function applyVariables(text, variables) {
      var replacedText = text;
      Object.keys(variables).filter(function (key) {
        return variables[key] && variables[key] !== 'unknown';
      }).forEach(function (key) {
        var re = new RegExp('\\${' + key + '}', 'g');
        replacedText = replacedText.replace(re, variables[key]);
      });
      return replacedText;
    }
  }, {
    key: "applyDefaults",
    value: function applyDefaults(text, defaultText) {
      if (/\${[a-zA-Z0-9]+}/.test(text)) {
        return defaultText;
      }

      return text;
    }
  }, {
    key: "performReplacements",
    value: function performReplacements(items, variables) {
      var _this = this;

      if (items && variables) {
        var itemsString = JSON.stringify(items);
        itemsString = this.applyVariables(itemsString, variables);
        var processedItems = JSON.parse(itemsString); // use default for any non replaced strings.

        processedItems.forEach(function (element) {
          var text = element.label;
          var defaultText = element.defaultLabel || '';
          element.label = _this.applyDefaults(text, defaultText);
        });
        return processedItems;
      }

      return items;
    }
  }, {
    key: "applySplit",
    value: function applySplit(items, split) {
      if (items && split) {
        window._expDataLayer = window._expDataLayer || [];

        window._expDataLayer.push({
          schema: 'add_experiment',
          version: 'v1',
          data: {
            experiment_id: split.experimentId,
            variant_id: split.variantId,
            experiment_source: 'SplitIO'
          }
        });

        var filteredItems = items.filter(function (element) {
          return !element.splitSide || element.splitSide === split.variantId;
        });
        return filteredItems;
      }

      return items;
    }
  }, {
    key: "applyVariableFilter",
    value: function applyVariableFilter(items, variables) {
      if (variables && items) {
        var filteredItems = items.filter(function (element) {
          if (!element.filter) {
            return true;
          }

          return variables[element.filter] !== 'unknown';
        });
        return filteredItems;
      }

      return items;
    }
  }, {
    key: "disableChatButtonIfOffline",
    value: function disableChatButtonIfOffline(buttons, availability) {
      return buttons.map(function (button) {
        if (button.id && button.id === 'chat') {
          button.enabled = availability;
        }

        return button;
      });
    }
  }, {
    key: "hasChatButton",
    value: function hasChatButton(item) {
      var buttons = item && item.payload && item.payload.items;
      return buttons && buttons.some(function (button) {
        return button.id && button.id === 'chat';
      });
    }
  }, {
    key: "getChatWaitTimeText",
    value: function getChatWaitTimeText(timeInSeconds) {
      if (timeInSeconds > 3600) {
        return 'more than 60 minutes';
      }

      if (timeInSeconds >= 120) {
        return "about ".concat(Math.floor(timeInSeconds / 60), " minutes");
      }

      if (timeInSeconds >= 0) {
        return 'about a minute';
      }

      return 'unknown';
    }
  }, {
    key: "getButtons",
    value: function getButtons(item, queryResult) {
      var items = item && item.payload && item.payload.items;

      if (items) {
        var processedItems = this.applySplit(items, queryResult.split);
        processedItems = this.applyVariableFilter(processedItems, queryResult.variables);
        processedItems = this.performReplacements(processedItems, queryResult.variables); // convert items to buttons while filtering

        var buttons = processedItems.map(function (button) {
          var id = button.id,
              label = button.label,
              event = button.event,
              link = button.link,
              style = button.style;
          var enabled = true;
          return {
            id: id,
            label: label,
            event: event,
            link: link,
            style: style,
            enabled: enabled
          };
        });
        this.disableChatButtonIfOffline(buttons, queryResult.variables.chatAvailability);
        return buttons;
      }

      return [];
    }
  }, {
    key: "getFallbackIntentEventId",
    value: function getFallbackIntentEventId(product) {
      return "welcome-".concat(product || 'default');
    }
  }]);

  return ChatbotsApiUtil;
}();

_defineProperty(ChatbotsApiUtil, "createModeXmlNode", function (phoneNo) {
  return "\n      <Data>\n        <Phone1>\n        <Cvalue>".concat(phoneNo, "</Cvalue>\n        <TZ>").concat(TZ, "</TZ>\n        </Phone1>\n      </Data>\n    ");
});

_defineProperty(ChatbotsApiUtil, "getBusinessFieldXml", function (payload) {
  var waitTime = payload.waitTime,
      timeStamp = payload.timeStamp,
      callbackTime = payload.callbackTime,
      callbackEndTime = payload.callbackEndTime,
      routeId = payload.routeId,
      callTypeID = payload.callTypeID,
      agentDisplay = payload.agentDisplay,
      firstName = payload.firstName,
      lastName = payload.lastName,
      shopperId = payload.shopperId,
      visitorId = payload.visitorId,
      ucid = payload.ucid;
  return "\n      <Data>\n        <AgentDisplay>".concat(agentDisplay, "</AgentDisplay>\n        <CallTypeID>").concat(callTypeID, "</CallTypeID>\n        <RouteId>").concat(routeId, "</RouteId>\n        <FirstName>").concat(firstName, "</FirstName>\n        <LastName>").concat(lastName, "</LastName>\n        <UCID>").concat(ucid, "</UCID>\n        <ShopperID>").concat(shopperId, "</ShopperID>\n        <VisitorID>").concat(visitorId, "</VisitorID>\n        <WaitTime>").concat(waitTime, "</WaitTime>\n        <TimeStamp>").concat(timeStamp, "</TimeStamp>\n        <CallbackTime>").concat(callbackTime, "</CallbackTime>\n        <CallbackEndTime>").concat(callbackEndTime, "</CallbackEndTime>\n      </Data>\n    ");
});

_defineProperty(ChatbotsApiUtil, "getTimeStamp", function (date, offsetInSec) {
  var copiedDate = new Date(date.getTime());

  if (offsetInSec) {
    copiedDate.setSeconds(date.getSeconds() + offsetInSec);
  }

  return copiedDate.toLocaleString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZone: 'America/Phoenix'
  }).replace(',', '');
});

_defineProperty(ChatbotsApiUtil, "getBusinessField", function (data) {
  var waitTimeInSec = data.waitTimeInSec,
      routeId = data.routeId,
      utterance = data.utterance,
      agentDisplay = data.agentDisplay,
      callTypeID = data.callTypeID;
  var date = new Date();
  var ucid = (0, _v["default"])();
  return _objectSpread({
    agentDisplay: agentDisplay,
    callTypeID: callTypeID,
    routeId: routeId,
    ucid: ucid
  }, (0, _util.getUserInfo)(), {
    phoneNo: utterance.replace(/\D/g, ''),
    waitTime: waitTimeInSec,
    timeStamp: ChatbotsApiUtil.getTimeStamp(date),
    callbackTime: ChatbotsApiUtil.getTimeStamp(date, waitTimeInSec),
    // waitTime plus current time
    callbackEndTime: ChatbotsApiUtil.getTimeStamp(date, waitTimeInSec + 60 * 60) // 1 hr after callbackTime

  });
});

_defineProperty(ChatbotsApiUtil, "createRacBody", function (businessFields) {
  var callbackTime = businessFields.callbackTime,
      callbackEndTime = businessFields.callbackEndTime;
  return {
    CreateContact: [{
      CampaignID: campaignId,
      Calltype: 0,
      callStartDateTime: callbackTime,
      callEndDateTime: callbackEndTime,
      BussinessFields: ChatbotsApiUtil.getBusinessFieldXml(businessFields),
      priority: 0,
      Modes: ChatbotsApiUtil.createModeXmlNode(businessFields.phoneNo),
      AgentID: '',
      SMSData: '',
      MailSubject: '',
      MailMsg: '',
      MailAttachment: '',
      ZipCode: '',
      ContactDetail: '',
      ListID: 0,
      LeadScore: 0
    }]
  };
});

var _default = ChatbotsApiUtil;
exports["default"] = _default;